const getters = {
  init: (state) => state.init.init,
  avatarBackground: (state) => state.customAvatar.avatarBackground
}
export default getters
